import { ExtendedConstructionNumber } from '@bpd-library/utilities';

/**
 * @description Generates a shopping cart url (VVK), if it returns false the shopping cart icon should not be shown.
 * @param {ExtendedConstructionNumber} constructionNumber
 * @return {*}  {(string | undefined)}
 */
const formatShoppingCartUrl = (
    constructionNumber: ExtendedConstructionNumber,
): string | undefined => {
    const {
        propertyType,
        identifier,
        propertyTypeId,
        projectPhaseId,
        areaProject,
        availabilityStatus,
        status: generatedStatus,
    } = constructionNumber;

    const propertyTypeStatus = propertyType?.status;

    // If an areaProject explicitely has no customer community set (no Mijn Eigen Huis), do not render shoppingcart url
    if (areaProject?.website) {
        if (!areaProject.website.enableCustomerCommunity) return;
    }

    let hasShoppingCartUrl = false;

    switch (propertyTypeStatus) {
        case 'SaleStarted':
            if (generatedStatus === 'Available') hasShoppingCartUrl = true;
            break;
        case 'AmountAvailable':
            if (generatedStatus && ['Available', 'InOption'].indexOf(generatedStatus) > -1)
                hasShoppingCartUrl = true;
            break;
        case 'AssigningOn':
            if (availabilityStatus === 'Available') hasShoppingCartUrl = true;
            break;
        case 'InOption':
            if (generatedStatus === 'InOption') hasShoppingCartUrl = true;
            break;
    }

    if (hasShoppingCartUrl) {
        if (!identifier || !projectPhaseId || !propertyTypeId) return;

        return `/umbraco/api/redirect/salestart?projectId=${projectPhaseId}&propertyId=${propertyTypeId}&constructionNumber=${identifier}`;
    }

    return;
};

export { formatShoppingCartUrl };
